
        <div class="row" [hidden]="msgHead.msg == ''">
            <div class="col-lg-6 col-md-8 col-xs-12">
                <alert [alert]="msgHead"></alert>
            </div>
        </div>
        <div class="row">
		    <div class="col-lg-12 col-md-12 col-xs-12" style="padding:0px;">
                <form [formGroup]="form" novalid>
                    <div class="row">
									<div class="col-lg-3 col-md-6 col-xs-12">
										<div class="form-group">
											<p class="custom-label">Identity Provider*</p>
											<select [(ngModel)]="idpIdValue" formControlName="idp" class="form-control" title="Identity Provider" placeholder="Select IdP">
												<option [ngValue]="0">Select Identity Provider</option>
												<option *ngFor="let idp of idP; let i = index" [value]="idp.id">{{idp.name}}</option>
											</select>
										</div>
										<div class="form-group">
											<p class="custom-label">Username</p>
											<input type="text" formControlName="userName" class="form-control" placeholder="Username">
										</div>
										<div class="form-group">
                                <p class="custom-label">First Name</p>
                                <input type="text" formControlName="firstName" class="form-control" placeholder="First Name">
                            	</div>
										<div class="form-group">
											<p class="custom-label">Last Name</p>
											<input type="text" formControlName="lastName" class="form-control" placeholder="Last Name">
										</div>
										<div class="form-group">
											<p class="custom-label">Card ID</p>
											<input type="text" formControlName="cardId" class="form-control" placeholder="Card ID">
								  		</div>
										<div class="form-group">
											<p class="custom-label">Phone Number</p>
											<input type="text" formControlName="phoneNumber" class="form-control" placeholder="Phone Number">
										</div>
										<div class="form-group">
											<p class="custom-label">Group Names (Comma Separated)</p>
											<input type="text" formControlName="groupNames" class="form-control" placeholder="Group Names">
										</div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
                <button type="button" class="btn btn-large btn-primary" (click)="save()">Save</button>
					 <a style="margin-left:10px;cursor: pointer;" *ngIf="!editMode" (click)="clearForm()">Clear Form</a>
					 <a style="margin-left:10px;cursor: pointer;" (click)="goBack()">Go Back</a>
            </div>
        </div>
        <div class="row" [hidden]="msg.msg == ''">
            <div class="col-lg-6 col-md-8 col-xs-12">
                <alert [alert]="msg"></alert>
            </div>
        </div>
    